module.exports = __webpack_public_path__ + "static/media/trainers-background-top.56070b6e.png";